<template>
  <div
    class="d2-layout-header-aside-group"
    :style="styleLayoutMainGroup"
    :class="{ grayMode: grayActive }"
  >
    <!-- 半透明遮罩 -->
    <div class="d2-layout-header-aside-mask"></div>
    <!-- 主体内容 -->
    <div class="d2-layout-header-aside-content" flex="dir:top">
      <!-- 顶栏 -->
      <!-- opacity: this.searchActive ? 0.5 : 1 -->
      <div
        class="d2-theme-header"
        :style="{
          opacity: 1
        }"
        flex-box="0"
        flex
      >
        <div
          class="logo-group"
          :style="{ width: asideCollapse ? asideWidthCollapse : asideWidth }"
          flex-box="0"
        >
          <img v-show="asideCollapse" class="logo-only" src="@/assets/main/logo.png" />
          <div v-show="!asideCollapse" class="logo">
            <img class="logo-img" src="@/assets/main/logo.png" />
            <div>鸿合云考勤</div>
          </div>
        </div>
        <div
          v-if="!(info.userType === '1' && info.analysisModule === '0')"
          class="toggle-aside-btn"
          @click="handleToggleAside"
          flex-box="0"
        >
          <!-- <d2-icon name="bars" /> -->
          <i class="el-icon-s-fold" title="收起" v-if="!asideCollapse" style="font-size: 24px"></i>
          <i class="el-icon-s-unfold" title="展开" v-if="asideCollapse" style="font-size: 24px"></i>
        </div>
        <d2-menu-center v-if="info.userType === '1' && info.analysisModule === '0'" flex-box="1" />
        <d2-menu-header v-else flex-box="1" />
        <!-- 顶栏右侧 -->
        <div
          v-if="!(info.userType === '1' && info.analysisModule === '0')"
          class="d2-header-right"
          :style="{ background: '#fff' }"
          flex-box="0"
        >
          <!-- 如果你只想在开发环境显示这个按钮请添加 v-if="$env === 'development'" -->
          <d2-header-user />
        </div>
        <div v-else class="d2-header-right" flex-box="0">
          <!-- 如果你只想在开发环境显示这个按钮请添加 v-if="$env === 'development'" -->
          <d2-header-user />
        </div>
      </div>
      <!-- 下面 主体 -->
      <div class="d2-theme-container" flex-box="1" flex>
        <!-- 主体 侧边栏 -->
        <div
          v-if="!(info.userType === '1' && info.analysisModule === '0')"
          flex-box="0"
          ref="aside"
          class="d2-theme-container-aside"
          :style="{
            width: asideCollapse ? asideWidthCollapse : asideWidth,
            opacity: 1
          }"
        >
          <!-- opacity: this.searchActive ? 0.5 : 1 -->
          <d2-menu-side />

          <template v-if="info.userType === '2' || info.userType === '5'">
            <el-popover
              v-if="!asideCollapse"
              key="tongbushuju-text"
              placement="top"
              trigger="hover"
              width="150"
              popper-class="tongbushuju-pop-top"
            >
              <div style="color: #FFFFFF;font-size: 12px;">
                点击该按钮，将获取最新的学生信息、教师信息、班级信息
              </div>
              <div slot="reference" class="tongbushuju" @click="handleTongbuShuJu('school')">
                同步数据
              </div>
            </el-popover>

            <el-popover
              v-if="asideCollapse"
              key="tongbushuju-icon"
              placement="right"
              trigger="hover"
              width="150"
              popper-class="tongbushuju-pop-right"
            >
              <div style="color: #FFFFFF;font-size: 12px;">
                点击该按钮，将获取最新的学生信息、教师信息、班级信息
              </div>
              <div slot="reference" class="tongbushuju-icon" @click="handleTongbuShuJu('school')">
                <img src="@/assets/main/icon_refresh.png" style="width: 12px;height: 12px;" />
              </div>
            </el-popover>
          </template>
        </div>
        <!-- 主体 -->

        <div
          :style="{
            width: asideCollapse ? 'calc(100% - 64px)' : 'calc(100% - 200px)',
            backgroundColor:
              info.userType === '1' && info.analysisModule === '0' ? '#eee' : '#102132 !important',
            height: '100%'
          }"
          class="d2-theme-container-main"
          flex-box="1"
          flex
        >
          <!-- 内容 -->
          <!-- v-if="!searchActive" -->
          <transition name="fade-scale">
            <div
              :style="{
                width: info.userType === '1' && info.analysisModule === '0' ? '1200px' : '100%',
                margin: '0 auto'
              }"
              class="d2-theme-container-main-layer"
              flex="dir:top"
            >
              <!-- 页面 -->
              <div class="d2-theme-container-main-body" flex-box="1">
                <transition :name="transitionActive ? 'fade-transverse' : ''">
                  <keep-alive :include="keepAlive">
                    <router-view />
                  </keep-alive>
                </transition>
              </div>
              <div class="page--content-footer">
                <div class="footer-download-disclaimer">
                  <span class="disclaimers" @click="handlerClickDownload">下载中心</span>
                  <span class="cutting-line">|</span>
                  <span class="disclaimers" @click="handlerClickDisclaimer">免责声明</span>
                </div>
                <div class="page--content-footer-copyright">
                  Copyright
                  <d2-icon name="copyright" />
                  <span>{{ new Date().getFullYear() }} 鸿合科技 All Rights Reserved</span>
                  <!-- <span class="cutting-line">|</span>
                  <span class="disclaimers" @click="handlerClick">免责声明</span>-->
                </div>
                <p class="register">
                  深圳市鸿合创新信息技术有限责任公司
                  <a style="text-decoration:none;;" target="_blank" href="http://beian.miit.gov.cn"
                    >网站备案号：京ICP备16055588号-1</a
                  >
                  <a
                    target="_blank"
                    href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802028495"
                    style="display:inline-block;vertical-align: bottom;"
                    >
                    <!-- <img
                      src="http://statics.hitecloud.net/public/rescenter/img/deian.png"
                      style="float:left;margin-top: 4px;height: 12px;"
                    /> -->
                    <img
                      src="@/assets/main/beian.png"
                      style="float:left;margin-top: 4px;height: 12px;"
                    />
                    <p style="float:left;margin: 0px 0px 0px 5px;">
                      京公网安备 11010802028495号
                    </p></a
                  >
                </p>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import d2MenuSide from './components/menu-side';
import d2MenuHeader from './components/menu-header';
import d2MenuCenter from './components/menu-header/center';
import d2HeaderUser from './components/header-user';
import { mapState, mapGetters, mapActions } from 'vuex';
import mixinSearch from './mixins/search';
import { Loading } from 'element-ui';
import { syncDataByTeacher } from '@/api/schoolManage';
import { Message } from 'element-ui';

export default {
  name: 'd2-layout-header-aside',
  mixins: [mixinSearch],
  components: {
    d2MenuSide,
    d2MenuHeader,
    d2MenuCenter,
    d2HeaderUser
  },
  data() {
    return {
      // [侧边栏宽度] 正常状态
      asideWidth: '200px',
      // [侧边栏宽度] 折叠状态
      asideWidthCollapse: '65px'
    };
  },
  computed: {
    ...mapState('d2admin', {
      keepAlive: state => state.page.keepAlive,
      grayActive: state => state.gray.active,
      transitionActive: state => state.transition.active,
      asideCollapse: state => state.menu.asideCollapse
    }),
    ...mapState('d2admin/user', ['info']),
    ...mapGetters('d2admin', {
      themeActiveSetting: 'theme/activeSetting'
    }),
    /**
     * @description 最外层容器的背景图片样式
     */
    styleLayoutMainGroup() {
      return {
        ...(this.themeActiveSetting.backgroundImage
          ? {
              backgroundImage: `url('${this.$baseUrl}${this.themeActiveSetting.backgroundImage}')`
            }
          : {})
      };
    }
  },
  methods: {
    ...mapActions('d2admin/menu', ['asideCollapseToggle']),
    /**
     * 接收点击切换侧边栏的按钮
     */
    handleToggleAside() {
      this.asideCollapseToggle().then(() => {
        setTimeout(() => {
          this.triggerWindowResizeEvent();
        }, 500);
      });
    },
    /**
     * 触发 window.resize
     */
    triggerWindowResizeEvent() {
      const event = document.createEvent('HTMLEvents');
      event.initEvent('resize', true, true);
      event.eventType = 'message';
      window.dispatchEvent(event);
    },
    handlerClickDisclaimer() {
      const routeData = this.$router.resolve({
        name: 'disclaimer'
      });
      window.open(routeData.href, '_blank');
    },
    handlerClickDownload() {
      const routeData = this.$router.resolve({
        name: 'download'
      });
      window.open(routeData.href, '_blank');
    },
    handleTongbuShuJu(date) {
      const params = {
        schoolId: '',
        teacherId: ''
      };
      params.schoolId = this.info.schoolId;
      if (date !== 'school') {
        params.teacherId = date.creater;
      }
      this.$confirm('是否确定进行数据同步?', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false,
        closeOnClickModal: false
      })
        .then(() => {
          let loadingInstance = Loading.service({
            target: '.app',
            background: 'rgba(0, 0, 0, 0.2)',
            text: '数据同步中'
          });
          syncDataByTeacher(params)
            .then(response => {
              this.syncLoading = true;
              if (response) {
                this.showSyncMessage('success', '数据同步成功');
                this.$nextTick(() => {
                  loadingInstance.close();
                });
                this.getSchoolTimeInfo();
              } else {
                // this.showSyncMessage('error', '数据同步失败');
              }
            })
            .catch(() => {
              this.$nextTick(() => {
                loadingInstance.close();
              });
            });
        })
        .catch(() => {});
    },
    showSyncMessage(type, msg) {
      return Message({
        message: msg,
        type: type,
        customClass: 'sync-message'
      });
    }
  }
};
</script>

<style lang="scss">
// 注册主题
@import '~@/assets/style/theme/register.scss';

.toggle-aside-btn,
.d2-theme-header-menu {
  background: #fff;
}

.theme-d2
  .d2-theme-container
  .d2-theme-container-main
  .d2-theme-container-main-body
  .container-component
  .d2-container-full {
  border: 0px solid #fff;
}

.d2-theme-header-menux {
  background: #102132;
}
.el-menu-item {
  height: 40px;
  line-height: 40px;
}
.el-pagination__jump {
  margin-left: 0;
}
.page--content-footer {
  text-align: center;
  color: #9c9da1;
  background: #eee;
  font-size: 14px;

  .page--content-footer-copyright {
    margin: 8px 0;
  }

  .register {
    margin: 0 0 8px 0;
    a {
      color: #9c9da1;

      &:hover {
        color: #03c449;
      }
    }
  }

  .cutting-line {
    margin: 0 8px;
  }

  .disclaimers {
    cursor: pointer;

    &:hover {
      color: #35d06d;
    }
  }
}

.tongbushuju-pop-top {
  background: #303133;
  border: 0 !important;

  .popper__arrow {
    border-top-color: #303133 !important;
    // border-right-color: #303133 !important;

    &:after {
      border-top-color: #303133 !important;
      // border-right-color: #303133 !important;
    }
  }
}
.tongbushuju-pop-right {
  background: #303133;
  border: 0 !important;

  .popper__arrow {
    border-right-color: #303133 !important;

    &:after {
      border-right-color: #303133 !important;
    }
  }
}
.tongbushuju {
  color: #ffffff;
  font-family: Microsoft YaHei;
  font-weight: regular;
  font-size: 16px;
  border-radius: 4px;
  border: 1px solid #e4e7ed;
  position: fixed;
  // position: absolute;
  bottom: 24px;
  left: 48px;
  height: 40px;
  width: 104px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    color: #62cd6c;
    font-family: Microsoft YaHei;
    font-weight: regular;
    font-size: 16px;
    border-radius: 4px;
    border: 1px solid #62cd6c;
  }
}

.tongbushuju-icon {
  color: #ffffff;
  font-family: Microsoft YaHei;
  font-weight: regular;
  border-radius: 4px;
  border: 1px solid #e4e7ed;
  // position: absolute;
  position: fixed;
  bottom: 24px;
  left: 16px;
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    color: #62cd6c;
    font-family: Microsoft YaHei;
    font-weight: regular;
    border-radius: 4px;
    border: 1px solid #62cd6c;
  }
}
.sync-message {
  width: 160px !important;
  max-width: 160px !important;
  min-width: 120px !important;
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/layout.vue"
}
</vue-filename-injector>
